const ACCORDION_ANIMATION_TRIGGER_SELECTOR = '.js-accordion'
const ACCORDION_ANIMATION_CONTENT_SELECTOR = '.accordion__content'
const ACCORDION_ANIMATION_DURATION = 300

const closeStyles = {
  height: 0,
  paddingBlock: 0,
  opacity: 0,
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(ACCORDION_ANIMATION_TRIGGER_SELECTOR).forEach(function (accordion) {
    const summary = accordion.querySelector("summary");
    const content = accordion.querySelector(ACCORDION_ANIMATION_CONTENT_SELECTOR);
    summary.addEventListener("click", (event) => {
      // デフォルトの挙動を無効化
      event.preventDefault();
      // detailsのopen属性を判定
      if (accordion.getAttribute("open") !== null) {
        // アコーディオンを閉じるときの処理
        const closingAnim = content.animate(closingAnimation(content), animTiming);

        closingAnim.onfinish = () => {
          // アニメーションの完了後にopen属性を取り除く
          accordion.removeAttribute("open");
        };
      } else {
        // open属性を付与
        accordion.setAttribute("open", "true");
        // アコーディオンを開くときの処理
        const openingAnim = content.animate(openingAnimation(content), animTiming);
      }
    });
  });
});

// アニメーションの時間とイージング
const animTiming = {
  duration: ACCORDION_ANIMATION_DURATION,
  easing: "ease-in-out",
};

// アコーディオンを閉じるときのキーフレーム
const closingAnimation = (content) => [
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
  {
    ...closeStyles
  },
];

// アコーディオンを開くときのキーフレーム
const openingAnimation = (content) => [
  {
    ...closeStyles
  },
  {
    height: content.offsetHeight + "px",
    opacity: 1,
  },
];